/**
 * Format pledge name for display.
 */
export const formatPledgeName = (
  pledgeName: string,
  t: (key: string, options?: { name: string }) => string,
): string => t('commitments.pledges.title', { name: pledgeName });

/**
 * Format pledge next installment date for display.
 */
export const formatPledgeFooter = (
  t: (key: string, options?: { date: string }) => string,
  nextInstallment?: string | null | undefined,
): string | null => {
  if (nextInstallment !== null && nextInstallment !== undefined) {
    return t('commitments.pledges.nextInstallment', {
      date: nextInstallment,
    });
  }
  return null;
};
